import React, { useEffect, useState } from 'react';
import TrashIcon from '../../app/components/svgIcons/TrashIcon';
import StyledLoading from '../../app/components/loading/StyledLoading';
import styled from 'styled-components';
import PlusIcon from '../../app/components/svgIcons/PlusIcon';
import DeleteConfirmation from '../../app/components/popups/DeleteConfirmation';
import UploadImagesPopUp from '../settings/components/UploadImagesPopUp';
import EditIcon from '../../app/components/svgIcons/EditIcon';
import NewLinkIcon from '../../app/components/svgIcons/link';
import AddImageIcon from '../../app/components/svgIcons/AddImageIcon';
import HeartFilled from '../../app/components/svgIcons/HeartFilled';
import HeartOutline from '../../app/components/svgIcons/HeartOutline';
import InfiniteScroll from 'react-infinite-scroll-component';
import StyledCheckIcon from '../../app/components/styledComponents/StyledCheckIcon';
import GalleryImageEditor from '../settings/components/GalleryImageEditor';
import { Offcanvas, OverlayTrigger } from 'react-bootstrap';
import EditOutlineIcon from '../../app/components/svgIcons/EditOutlineIcon';
import RemoveBackgroundIcon from '../../app/components/svgIcons/RemoveBackgroundIcon';
import { useSelector } from 'react-redux';
import moment from 'moment';
import StyledText from '../../app/components/styledComponents/StyledText';
import { hexToRgbA, isAuthorized } from '../../utils/helper';
import { useDispatch } from 'react-redux';
import { StyledTooltip } from '../../app/components/styledComponents/StyledTooltip';
import {
  setIsShowProcessedImage,
  setRemoveBackgroundImageData,
} from '../../app/services/removeBackground';
import StyledCheckbox from '../../app/components/checkbox/StyledCheckbox';
import { ShopStyled } from '../shopSetting/assets/shopStyled';

const ImagesContainer = styled.div`
  border-top-right-radius: 0 !important;
  border-top-left-radius: 0 !important;
  background-color: ${({ theme }) => theme.white};
  padding: 1rem;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const ImageItem = styled.div`
  align-self: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12px;
  position: relative;
`;

const StyledLoadingContainer = styled.div`
  background-color: ${({ theme }) => theme.white};
  height: 200px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledUserImage = styled.div`
  width: 270px;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &:after {
    content: '\\A';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    opacity: 0;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
  }

  .image-btn {
    opacity: 0;
  }

  &:hover,
  &.force-hover {
    .image-btn {
      opacity: 1;
    }
    &:after {
      opacity: 1;
    }
  }
`;

const OverlayView = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  opacity: 1;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
`;

const DeleteIcon = styled.span`
  position: relative;
  width: fit-content;
  font-size: 18px;
  color: ${({ theme }) => theme.danger};
  cursor: pointer;
  opacity: 0;
  z-index: 98;
  background: ${({ theme, transparent = false }) =>
    transparent ? 'transparent' : theme.grayBg};
  padding: 2px 9px 4px 9px;
  border-radius: 50%;

  &.edit-grp {
    padding: 2px 8px 4px 10px;
  }

  .edit-btn {
    top: 0;
    right: 10px;
  }
`;

const AddIconDiv = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  opacity: 0;
  z-index: 98;
  background: ${({ theme }) => theme.grayBg};
  padding: 15px !important;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  &.add-grp {
    left: 42%;
  }
  &.fav-grp {
    left: 58%;
    padding: 2px 8px 4px 10px;
  }
`;

const UploadIcon = styled.div`
  position: relative;
  label {
    width: 270px;
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    color: ${({ theme }) => theme.heading};
    border: 1px dashed ${({ theme }) => theme.dark50};
    background-color: ${({ theme }) => theme.dark95};
    cursor: pointer;
    border-radius: 8px;
    span {
      font-size: 16px;
      color: ${({ theme }) => theme.heading};
      font-weight: 500;
      &:first-child {
        margin-bottom: 10px;
      }
      svg {
        color: ${({ theme }) => theme.icon};
      }
    }
  }
`;

const ProgressContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);

  .CircularProgressbar {
    height: 80px;
  }
`;

const UploadedLabelContainer = styled.div`
  position: absolute;
  left: 0;
  z-index: 1;
`;

const StyledTag = styled.span`
  margin-top: 10px;
  padding: 4px 12px 4px 12px;
  color: ${({ theme }) => theme.white};
  background-color: ${({ theme }) => hexToRgbA(theme.primary, 0.5)};
  font-family: ${(theme) => theme.fontFamily};
  border-radius: 0 20px 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const GalleryContainer = ({
  // handleUpload,
  handleDelete = () => {},
  handleFavImage = () => {},
  images = [],
  loading,
  initialLoading,
  last,
  comingFrom,
  isFlorist,
  setImages,
  selectedImage,
  handleImageEditOrSave,
  fetchNext,
  selectMulti,
  selectedImagesArray,
  tags,
  filter,
  selectedTab,
  imageCategories= []
}) => {
  const [currentTime, setCurrentTime] = useState(moment());
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [showImageUpload, setShowImageUpload] = React.useState(false);
  const [editImage, setEditImage] = React.useState(null);
  const [isImgEditorShown, setIsImgEditorShown] = useState(false);
  const [isHovered, setIsHovered] = useState(null);
  const [processText, setProcessText] = useState(' Converting to WebP... ');
  useEffect(() => {
    const timeout1 = setTimeout(() => {
      setProcessText('Creating thumbnail....');
    }, 2000); // After 2 seconds

    const timeout2 = setTimeout(() => {
      setProcessText('Finalizing image...');
    }, 4000); // After another 2 seconds (total 4 seconds)

    // Clean up the timeouts on component unmount (optional)
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, []); // Only run once when the component mounts

  const handleMouseEnter = (id) => setIsHovered(id);
  const handleMouseLeave = () => setIsHovered(null);

  const dispatch = useDispatch();

  const [copied, setCopiedLink] = useState([]);
  const uploadingImages =
    useSelector((state) => state.imagesGallery)?.[
      isFlorist === 'yourImages' ? 'floristImages' : 'inventoryImages'
    ] ?? [];

  const userPermissions = useSelector(
    (state) => state?.authorization?.userPermissions,
  );

  const has_permission_to_update_gallery = isAuthorized(
    userPermissions,
    'can_update_gallery',
  );

  const RemoveBackgroundData = useSelector(
    (state) => state.removeBackground ?? [],
  );

  const handlePreviewOpen = (image) => {
    setEditImage(image);
    setOpen(true);
  };

  const handlePreviewClose = () => {
    setEditImage(null);
    setOpen(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, [10000]);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {initialLoading ? (
        <StyledLoadingContainer>
          <StyledLoading />
        </StyledLoadingContainer>
      ) : (
        <></>
      )}

      {!initialLoading && (
        <InfiniteScroll
          dataLength={images.length}
          next={fetchNext}
          hasMore={!last}
          style={{ overflow: 'visible' }}
          {...(comingFrom ? { scrollableTarget: comingFrom } : {})}
        >
          <ImagesContainer>
            {isFlorist !== 'boostFloralImages' && (
              <>
                {!loading || images.length ? (
                  <OverlayTrigger
                    overlay={
                      has_permission_to_update_gallery ? (
                        <></>
                      ) : (
                        <StyledTooltip>
                          You don't have permission to update gallery
                        </StyledTooltip>
                      )
                    }
                  >
                    <ImageItem
                      className={
                        has_permission_to_update_gallery
                          ? `cursor-pointer`
                          : 'cursor-not-allowed'
                      }
                      onClick={() =>
                        has_permission_to_update_gallery &&
                        setShowImageUpload(true)
                      }
                    >
                      <UploadIcon
                        className={
                          has_permission_to_update_gallery
                            ? `cursor-pointer`
                            : 'cursor-not-allowed'
                        }
                      >
                        <label
                          name="uploadImage"
                          className={
                            has_permission_to_update_gallery
                              ? `cursor-pointer`
                              : 'cursor-not-allowed opacity-50'
                          }
                        >
                          <span>
                            <AddImageIcon />
                          </span>
                          <span>Upload Photos</span>
                        </label>
                      </UploadIcon>
                    </ImageItem>
                  </OverlayTrigger>
                ) : (
                  <></>
                )}
              </>
            )}

            {[...uploadingImages, ...(images ?? [])]?.map((image, index) => {
              const duration = image.uploadedOn
                ? moment.duration(moment().diff(moment(image.uploadedOn)))
                : null;
              return (
                <ImageItem key={index} onClick={() => handlePreviewOpen(image)}>
                  <StyledUserImage
                    className={`position-relative cursor-pointer flex-center align-items-center justify-content-center Image-${index} ${
                      isHovered === image.id ? 'force-hover' : ''
                    }`}
                    onMouseEnter={() => handleMouseEnter(image.id)}
                    onMouseLeave={handleMouseLeave}
                  >
                    <img
                      src={(() => {
                        const uploadedTime = moment.utc(image.uploadedOn);
                        const timeDifference = currentTime.diff(
                          uploadedTime,
                          'seconds',
                        );
                        return timeDifference < 10
                          ? image.imageDTO.url
                          : image.imageDTO.thumbnailUrl;
                      })()}
                      alt={''}
                      loading={'lazy'}
                    />

                    {duration?.asDays() <= 1 ? (
                      <UploadedLabelContainer
                        style={{
                          bottom:
                            process.env
                              .REACT_APP_GALLERY_FILTER_LAYOUT_ENABLED ===
                            'true'
                              ? '12px'
                              : '0px',
                          ...(process.env
                            .REACT_APP_GALLERY_FILTER_LAYOUT_ENABLED !==
                            'true' && {
                            top: 0,
                          }),
                        }}
                      >
                        <StyledTag>
                          <StyledText
                            $fontSize="14px"
                            $fontWeight="500"
                            color="white"
                            className="m-0"
                          >
                            Uploaded Today
                          </StyledText>
                        </StyledTag>
                      </UploadedLabelContainer>
                    ) : (
                      duration?.asDays() <= 7 && (
                        <UploadedLabelContainer
                          style={{
                            bottom:
                              process.env
                                .REACT_APP_GALLERY_FILTER_LAYOUT_ENABLED ===
                              'true'
                                ? '12px'
                                : '0px',
                            ...(process.env
                              .REACT_APP_GALLERY_FILTER_LAYOUT_ENABLED !==
                              'true' && {
                              top: 0,
                            }),
                          }}
                        >
                          <StyledTag>
                            <StyledText
                              $fontSize="14px"
                              $fontWeight="500"
                              color="white"
                              className="m-0"
                            >
                              Uploaded Recently
                            </StyledText>
                          </StyledTag>
                        </UploadedLabelContainer>
                      )
                    )}

                    {comingFrom !== 'imageSelection' &&
                      isFlorist !== 'boostFloralImages' &&
                      process.env.REACT_APP_GALLERY_FILTER_LAYOUT_ENABLED ===
                        'true' && (
                        <div
                          style={{
                            position: 'absolute',
                            top: '10px',
                            left: '10px',
                            zIndex: 10,
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <ShopStyled.EditButton
                            color={'dark70'}
                            variant={'outline'}
                            padding="0px"
                            type="button"
                            className="border-0"
                            childrenProps={{
                              className: 'd-flex align-items-center gap-2',
                            }}
                          >
                            <StyledCheckbox
                              // name={`variation-${index}.defaultVariationCheckbox`}
                              value={selectedImagesArray?.some(
                                (imgObj) => imgObj?.id === image?.id,
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  selectedImage([
                                    ...selectedImagesArray,
                                    image,
                                  ]);
                                } else {
                                  const updated = selectedImagesArray.filter(
                                    (imgObj) => imgObj?.id !== image?.id,
                                  );
                                  selectedImage(updated);
                                }
                              }}
                              style={{
                                border: '2px solid #ef874c',
                              }}
                            />
                          </ShopStyled.EditButton>
                        </div>
                      )}

                    {image.uploading ||
                    RemoveBackgroundData?.isImageProcessing?.includes(
                      image.id,
                    ) ? (
                      <ProgressContainer>
                        {image?.progress == undefined ||
                        image?.progress == 100 ? (
                          <div className="d-flex flex-row justify-content-center align-items-center">
                            <StyledLoading
                              color={'#fff'}
                              style={{
                                height: '1rem',
                                width: '1rem',
                                fontSize: '12px',
                              }}
                            />
                            <StyledText
                              $fontSize="14px"
                              $fontWeight="500"
                              color="white"
                              className="mx-2 mb-0"
                            >
                              {processText}
                            </StyledText>
                          </div>
                        ) : (
                          <>
                            <StyledLoading
                              color={'#fff'}
                              style={{ height: '4rem', width: '4rem' }}
                            />
                            <div
                              className="position-absolute"
                              style={{
                                display: image.uploading ? 'block' : 'none',
                              }}
                            >
                              <StyledText color="white">
                                {image?.progress ? `${image.progress}%` : '0%'}
                              </StyledText>
                            </div>
                          </>
                        )}
                      </ProgressContainer>
                    ) : comingFrom === 'imageSelection' ? (
                      <div
                        style={{
                          height: '100%',
                          width: '100%',
                          position: 'absolute',
                        }}
                      >
                        {selectMulti && (
                          <>
                            {selectedImagesArray.includes(
                              // image?.imageDTO?.thumbnailUrl ||
                              image?.imageDTO?.url,
                            ) ? (
                              <>
                                <AddIconDiv
                                  style={{
                                    left: '50%',
                                    top: '50%',
                                  }}
                                  className="image-btn add-grp"
                                  onClick={(e) => {
                                    selectedImage(
                                      selectedImagesArray?.filter(
                                        (url) =>
                                          url !==
                                          // image?.imageDTO?.thumbnailUrl ||
                                          image?.imageDTO?.url,
                                      ),
                                    );
                                    e.stopPropagation();
                                  }}
                                >
                                  <StyledCheckIcon color={'primaryGreen'} />
                                </AddIconDiv>
                                <OverlayView />
                              </>
                            ) : (
                              <AddIconDiv
                                style={{
                                  left: '50%',
                                  top: '50%',
                                }}
                                className="image-btn"
                                onClick={(e) => {
                                  selectedImage([
                                    ...selectedImagesArray,
                                    // image?.imageDTO?.thumbnailUrl ||
                                    image?.imageDTO?.url,
                                  ]);
                                  e.stopPropagation();
                                }}
                              >
                                <PlusIcon size={23} />
                              </AddIconDiv>
                            )}
                          </>
                        )}
                        {!selectMulti && (
                          <AddIconDiv
                            className="image-btn add-grp"
                            style={{
                              left: '50%',
                              top: '50%',
                            }}
                            onClick={(e) => {
                              selectedImage(
                                // image?.imageDTO?.thumbnailUrl ||
                                image?.imageDTO?.url,
                              );
                              e.stopPropagation();
                            }}
                          >
                            <PlusIcon size={23} />
                          </AddIconDiv>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          bottom: 0,
                          height: '100%',
                          width: '100%',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end',
                            padding: '10px',
                            gap: '3px',
                          }}
                        >
                          {has_permission_to_update_gallery &&
                            !selectedImagesArray?.some(
                              (imgObj) => imgObj?.id === image?.id,
                            ) && (
                              <OverlayTrigger
                                overlay={
                                  <StyledTooltip>Edit Image</StyledTooltip>
                                }
                                onMouseEnter={() => handleMouseEnter(image.id)}
                                onMouseLeave={handleMouseLeave}
                              >
                                <DeleteIcon
                                  title="Edit Image"
                                  onClick={(e) => {
                                    setEditImage(image);
                                    setShowImageUpload(false);
                                    setIsImgEditorShown(true);
                                    e.stopPropagation();
                                  }}
                                  className="image-btn edit-grp"
                                  style={{
                                    height:
                                      comingFrom === 'imageSelection' ? 40 : 33,
                                    width:
                                      comingFrom === 'imageSelection' ? 40 : 33,
                                    display:
                                      comingFrom === 'imageSelection'
                                        ? 'none'
                                        : 'block',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    left:
                                      comingFrom === 'imageSelection' && '14px',
                                  }}
                                >
                                  <EditOutlineIcon size={15} fill="#bb2124" />
                                </DeleteIcon>
                              </OverlayTrigger>
                            )}
                          {/* -------------------------------------------------------- */}

                          {isFlorist !== 'boostFloralImages' &&
                            !selectedImagesArray?.some(
                              (imgObj) => imgObj?.id === image?.id,
                            ) &&
                            comingFrom !== 'imageSelection' && (
                              <>
                                {has_permission_to_update_gallery && (
                                  <OverlayTrigger
                                    overlay={
                                      <StyledTooltip>
                                        Edit Background
                                      </StyledTooltip>
                                    }
                                    onMouseEnter={() =>
                                      handleMouseEnter(image.id)
                                    }
                                    onMouseLeave={handleMouseLeave}
                                  >
                                    <DeleteIcon
                                      title="Edit Background Image"
                                      onClick={(e) => {
                                        const updatedImages = { ...image };
                                        updatedImages.processedImageUrl =
                                          image?.imageDTO?.url || '';
                                        updatedImages.processed = false;
                                        dispatch(
                                          setRemoveBackgroundImageData(
                                            updatedImages,
                                          ),
                                        );
                                        dispatch(
                                          setIsShowProcessedImage(image?.id),
                                        );
                                        setShowImageUpload(false);
                                        e.stopPropagation();
                                      }}
                                      className="image-btn"
                                      style={{
                                        height:
                                          comingFrom === 'imageSelection'
                                            ? 40
                                            : 33,
                                        width:
                                          comingFrom === 'imageSelection'
                                            ? 40
                                            : 33,
                                        display:
                                          comingFrom === 'imageSelection'
                                            ? 'flex'
                                            : 'block',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        left:
                                          comingFrom === 'imageSelection' &&
                                          '14px',
                                      }}
                                    >
                                      <RemoveBackgroundIcon
                                        size={15}
                                        fill="#bb2124"
                                      />
                                    </DeleteIcon>
                                  </OverlayTrigger>
                                )}
                              </>
                            )}

                          {/* -------------------------------------------------------- */}
                          {comingFrom !== 'imageSelection' &&
                            !selectedImagesArray?.some(
                              (imgObj) => imgObj?.id === image?.id,
                            ) &&
                            (isFlorist !== 'boostFloralImages' ? (
                              <>
                                {has_permission_to_update_gallery && (
                                  <>
                                    <OverlayTrigger
                                      overlay={
                                        <StyledTooltip>
                                          Edit Tags & SEO Details
                                        </StyledTooltip>
                                      }
                                      onMouseEnter={() =>
                                        handleMouseEnter(image.id)
                                      }
                                      onMouseLeave={handleMouseLeave}
                                    >
                                      <DeleteIcon
                                        className="image-btn edit-grp"
                                        onClick={(e) => {
                                          setEditImage({ ...image, index: 0 });
                                          setShowImageUpload(true);
                                          e.stopPropagation();
                                        }}
                                      >
                                        <EditIcon size="14px" />
                                      </DeleteIcon>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                      overlay={
                                        <StyledTooltip>
                                          {copied.includes(image?.id)
                                            ? 'Link Copied'
                                            : 'Copy Image Link'}
                                        </StyledTooltip>
                                      }
                                      onMouseEnter={() =>
                                        handleMouseEnter(image.id)
                                      }
                                      onMouseLeave={handleMouseLeave}
                                    >
                                      <DeleteIcon
                                        className="image-btn delete-grp"
                                        onClick={(e) => {
                                          navigator.clipboard.writeText(
                                            image?.imageDTO?.url,
                                          );

                                          setCopiedLink((prevState) =>
                                            prevState.includes(image?.id)
                                              ? prevState
                                              : [...prevState, image?.id],
                                          );

                                          setTimeout(
                                            () =>
                                              setCopiedLink((prevState) =>
                                                prevState.filter(
                                                  (id) => id !== image?.id,
                                                ),
                                              ),
                                            500,
                                          );

                                          setShowImageUpload(false);
                                          e.stopPropagation();
                                        }}
                                      >
                                        <NewLinkIcon size={14} />
                                      </DeleteIcon>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                      overlay={
                                        <StyledTooltip>
                                          Delete Image
                                        </StyledTooltip>
                                      }
                                      onMouseEnter={() =>
                                        handleMouseEnter(image.id)
                                      }
                                      onMouseLeave={handleMouseLeave}
                                    >
                                      <DeleteIcon
                                        className="image-btn delete-grp"
                                        onClick={(e) => {
                                          setShowDeleteConfirmation(true);
                                          setIdToDelete(image?.imageDTO?.id);
                                          e.stopPropagation();
                                        }}
                                      >
                                        <TrashIcon />
                                      </DeleteIcon>
                                    </OverlayTrigger>
                                  </>
                                )}
                              </>
                            ) : (
                              <DeleteIcon
                                transparent
                                className="image-btn"
                                style={{ padding: '0px' }}
                                onClick={(e) => {
                                  handleFavImage(
                                    {
                                      floristImageId: image?.imageDTO?.id,
                                      favourite: !image?.favorite,
                                    },
                                    index,
                                  );
                                  e.stopPropagation();
                                }}
                              >
                                {image?.favorite ? (
                                  <HeartFilled size={35} />
                                ) : (
                                  <HeartOutline size={35} />
                                )}
                              </DeleteIcon>
                            ))}
                        </div>
                      </div>
                    )}
                  </StyledUserImage>
                </ImageItem>
              );
            })}
          </ImagesContainer>
        </InfiniteScroll>
      )}

      {loading && !initialLoading ? (
        <StyledLoadingContainer>
          <StyledLoading />
        </StyledLoadingContainer>
      ) : (
        <></>
      )}

      <DeleteConfirmation
        show={showDeleteConfirmation}
        onDelete={() => {
          handleDelete(idToDelete);
          setShowDeleteConfirmation(false);
          setIdToDelete(null);
        }}
        onCancel={() => {
          setShowDeleteConfirmation(false);
          setIdToDelete(null);
        }}
      />

      <UploadImagesPopUp
        show={open}
        onCancel={handlePreviewClose}
        singleEditImage={editImage}
        previewModal
        selectedTab={selectedTab}
      />

      <UploadImagesPopUp
        setImages={setImages}
        images={images}
        filter={filter}
        isFlorist={isFlorist}
        show={showImageUpload}
        onCancel={() => {
          setShowImageUpload(false);
          setEditImage(null);
        }}
        singleEditImage={editImage}
        handleImageEditOrSave={handleImageEditOrSave}
        comingFrom={comingFrom}
        tags={tags}
        categories={imageCategories}
        openEditPopUp={() => {
          setShowImageUpload(false);
          // setEditImage(null);
          setIsImgEditorShown(true);
        }}
        selectedTab={selectedTab}
      />

      <Offcanvas
        show={isImgEditorShown}
        onHide={() => {
          setEditImage(null);
          setIsImgEditorShown(false);
        }}
        placement={'end'}
        style={{ width: '90%', zIndex: 1050 }}
      >
        <Offcanvas.Body>
          <GalleryImageEditor
            editImage={editImage}
            onClose={() => {
              setIsImgEditorShown(false);
              setEditImage(null);
            }}
            updateData={() => {
              setIsImgEditorShown(false);
              setEditImage(null);
              handleImageEditOrSave(null, 'initial');
            }}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default GalleryContainer;
